(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-text"] && !Shopify.designMode) return;
  try {
    
  // Initialize section-specific JavaScript once DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    var sectionContainer = document.getElementById('ImageWithText-{{ section.id }}');
    if (!sectionContainer) return;

    var images = sectionContainer.querySelectorAll('.products-with-blocks__image img');
    images.forEach(function(img) {
      // Add 'loaded' class when image is fully loaded
      img.addEventListener('load', function() {
        this.classList.add('loaded');
      });
      // Log errors for debugging
      img.addEventListener('error', function() {
        console.error('Image failed to load:', this.dataset.src);
      });
    });

    // Fallback: if lazySizes (or similar) is not defined, set actual src manually
    if (typeof lazySizes === 'undefined') {
      images.forEach(function(img) {
        if (img.dataset && img.dataset.src) {
          img.src = img.dataset.src;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["information"] && !Shopify.designMode) return;
  try {
    
  // Lazy-load fallback: if lazySizes (or similar) is not available, load images manually.
  document.addEventListener('DOMContentLoaded', function() {
    var images = document.querySelectorAll('.lazyload');
    if (typeof lazySizes === 'undefined') {
      images.forEach(function(img) {
        if (img.dataset && img.dataset.src) {
          img.src = img.dataset.src;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preparation"] && !Shopify.designMode) return;
  try {
    
  // Image loading
  document.addEventListener('DOMContentLoaded', function() {
    // Apply loaded class to already visible images
    var visibleImages = document.querySelectorAll('.lazyload:not([loading="lazy"])');
    visibleImages.forEach(function(img) {
      img.classList.add('loaded');
    });

    // Handle lazySizes fallback
    if (typeof lazySizes === 'undefined') {
      // Set up intersection observer for better lazy loading
      if ('IntersectionObserver' in window) {
        var imageObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var img = entry.target;
              if (img.dataset && img.dataset.src) {
                img.src = img.dataset.src;
                img.onload = function() {
                  img.classList.add('loaded');
                };
                imageObserver.unobserve(img);
              }
            }
          });
        });

        document.querySelectorAll('.lazyload[loading="lazy"]').forEach(function(img) {
          imageObserver.observe(img);
        });
      } else {
        // Fallback for older browsers without IntersectionObserver
        document.querySelectorAll('.lazyload[loading="lazy"]').forEach(function(img) {
          if (img.dataset && img.dataset.src) {
            var newImg = new Image();
            newImg.onload = function() {
              img.src = img.dataset.src;
              img.classList.add('loaded');
            };
            newImg.src = img.dataset.src;
          }
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technical_details"] && !Shopify.designMode) return;
  try {
    
  // Image loading
  document.addEventListener('DOMContentLoaded', function() {
    // Apply loaded class to already visible images
    var visibleImages = document.querySelectorAll('.lazyload:not([loading="lazy"])');
    visibleImages.forEach(function(img) {
      img.classList.add('loaded');
    });

    // Handle lazySizes fallback
    if (typeof lazySizes === 'undefined') {
      // Set up intersection observer for better lazy loading
      if ('IntersectionObserver' in window) {
        var imageObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var img = entry.target;
              if (img.dataset && img.dataset.src) {
                img.src = img.dataset.src;
                img.onload = function() {
                  img.classList.add('loaded');
                };
                imageObserver.unobserve(img);
              }
            }
          });
        });

        document.querySelectorAll('.lazyload[loading="lazy"]').forEach(function(img) {
          imageObserver.observe(img);
        });
      } else {
        // Fallback for older browsers without IntersectionObserver
        document.querySelectorAll('.lazyload[loading="lazy"]').forEach(function(img) {
          if (img.dataset && img.dataset.src) {
            var newImg = new Image();
            newImg.onload = function() {
              img.src = img.dataset.src;
              img.classList.add('loaded');
            };
            newImg.src = img.dataset.src;
          }
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
